import { createSelector } from '@reduxjs/toolkit';
import { GlobalState } from 'reducers/stateTypes';

export const selectShowSecondLevelTabs = createSelector(
  (state: GlobalState) => state.partnerForm,
  (pF) => pF.showSecondLevelTabs,
);
